import { Component, EventEmitter, Input, Output, SimpleChanges } from '@angular/core';
import { FormControl } from '@angular/forms';
import { PriceOptionEnum } from '../../enums';


@Component({
  selector: 'rnpl-price-option-toggle-control',
  templateUrl: './price-option-toggle-control.component.html',
  styleUrls: ['./price-option-toggle-control.component.scss'],
})
export class PriceOptionToggleControlComponent {

  public priceOptionEnum = PriceOptionEnum;
  public control: FormControl = new FormControl();

  @Input() value: PriceOptionEnum = null;
  @Input() disabled: boolean = false;
  @Output() fieldChanged: EventEmitter<PriceOptionEnum> = new EventEmitter<PriceOptionEnum>();


  constructor() {
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes && changes.hasOwnProperty('disabled') && this.control) {
      if (this.disabled) {
        this.control.disable();
      } else {
        this.control.enable();
      }
    }
    if (changes && changes.hasOwnProperty('value') && this.value) {
      this.control.patchValue(this.value);
    }
  }

  public updateField(fieldValue: PriceOptionEnum): void {
    this.fieldChanged.emit(fieldValue);
  }

}
